define.alias("ember-cli-clipboard/components/copy-button", "preview-grid/components/copy-button");